import { Collapse, Skeleton, Typography } from "antd"
import { useApprovedPaymentSummariesQuery } from "../../../domain/proposals/paymentSummaryQueries"
import { useWorkareaGroupsQuery } from "../../../domain/workareas/groupsQueries"
import Summary from "./Summary"
import dayjs from "dayjs"
import { WorkareaGroup } from "../../../domain/workareas/group"
import { ApprovedPaymentSummary } from "../../../domain/proposals/paymentSummary"
import SectionCard from "../../common/SectionCard"

export type Props = {
  jobId: number
}

const ApprovedPaymentSummaries = ({jobId}: Props) => {
  const approvedPaymentSummariesQuery = useApprovedPaymentSummariesQuery(jobId)
  const workareaGroupsQuery = useWorkareaGroupsQuery(jobId)
  const loading = approvedPaymentSummariesQuery.isLoading || workareaGroupsQuery.isLoading

  return <SectionCard title="Approved Invoicing Schedule">
    <Summaries
      loading={loading}
      summaries={approvedPaymentSummariesQuery.data ?? []}
      workareaGroups={workareaGroupsQuery.data ?? []}
    />
  </SectionCard>
}

export default ApprovedPaymentSummaries

type SummariesProps = {
  loading: boolean
  summaries: ApprovedPaymentSummary[]
  workareaGroups: WorkareaGroup[]
}

const Summaries = ({loading, summaries, workareaGroups}: SummariesProps) => {
  if (loading) {
    return <Skeleton active />
  }

  if (!summaries.length) {
    return <Typography.Text type="secondary">No approved payment summaries were found.</Typography.Text>
  }

  return <Collapse
    items={summaries.map(x => ({
      key: x.proposalId,
      label: <span>Approved: {dayjs(x.approvedAt).format('MMM D, YYYY')} at {dayjs(x.approvedAt).format('hh:mm a')}</span>,
      children: <Summary summary={x} workareaGroups={workareaGroups} />
    }))}
  />
}